import { UNIUNI_US_WAREHOUSES } from "@redotech/redo-model/outbound-labels/uniuni-warehouses";
import { RedoTextInput } from "@redotech/redo-web/arbiter-components/input/redo-text-input";
import { RedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";
import { RedoSingleSelectDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { groupInput, input, InputProvider } from "@redotech/ui/form";
import { memo, useMemo } from "react";

export const uniUniDirectIntegrationSettingsForm = groupInput({
  enabled: input<boolean>(),
  pickupWarehouseId: input<number | null>(),
  customerId: input<string>(),
});

export type UniUniDirectIntegrationSettingsForm = InputProvider.Form<
  typeof uniUniDirectIntegrationSettingsForm
>;

export type UniUniDirectIntegrationSettingsValue = InputProvider.Value<
  typeof uniUniDirectIntegrationSettingsForm
>;

export const uniUniDirectIntegrationSettingsDefault: UniUniDirectIntegrationSettingsValue =
  { enabled: false, pickupWarehouseId: null, customerId: "" };

export const UniUniDirectIntegrationSettings = memo(
  function UniUniDirectIntegrationSettings({
    input,
  }: {
    input: UniUniDirectIntegrationSettingsForm;
  }) {
    const { inputs } = input;

    const warehouseOptions: RedoListItem<number>[] = useMemo(
      () =>
        UNIUNI_US_WAREHOUSES.map((w) => ({
          id: String(w.id),
          type: "text" as const,
          text: `${w.code} — ${w.label}`,
          value: w.id,
        })),
      [],
    );

    return (
      <Flex dir="column" gap="md" mt="md">
        <Flex dir="column" gap="sm" w="sm">
          <Text fontSize="xs" fontWeight="medium">
            Pickup Warehouse
          </Text>
          <RedoSingleSelectDropdownInput<number>
            options={warehouseOptions}
            optionSelected={({ item }) => {
              inputs.pickupWarehouseId.setValue(item.value);
            }}
            placeholder="Select pickup warehouse"
            selectedItem={warehouseOptions.find(
              (o) => o.value === inputs.pickupWarehouseId.value,
            )}
            size="xs"
          />

          <Text fontSize="xs" fontWeight="medium" mt="sm">
            Customer ID
          </Text>
          <RedoTextInput
            placeholder="Enter UniUni customer ID (e.g. 3671)"
            setValue={inputs.customerId.setValue}
            value={inputs.customerId.value}
          />
        </Flex>
      </Flex>
    );
  },
);
